import React from 'react'
import styled from 'styled-components'
import { Icon } from '../icon'

export interface AssetCardProps {
  className?: string
  uploader: {
    name: string
    avatar: string
  }
  viewCount?: number
  likeCount?: number
  commentCount?: number
}

const Container = styled.div`
  width: 100%;
  padding: 0.75rem;
  border-radius: 0.25rem;
  box-shadow: ${props => props.theme.shadows.outline};
  overflow: hidden;
`
const ChildrenContainer = styled.div`
  margin-bottom: 0.75rem;
`
const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Uploader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  img {
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 0.25rem;
    border-radius: 50%;
    vertical-align: bottom;
  }
  span {
    font-size: 0.75rem;
  }
`
const Counts = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`
const Count = styled.div`
  flex: none;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  & > * + * {
    margin-left: 0.25rem;
  }
  span {
    font-size: 0.75rem;
    color: ${props => props.theme.colors.textTip};
  }
`
const CountIcon = styled(Icon).attrs(props => ({
  size: '0.875rem',
  color: props.theme.colors.textTip
}))``
export const AssetCard: React.FC<AssetCardProps> = ({
  className,
  uploader: {
    name,
    avatar
  },
  viewCount = 0,
  likeCount = 0,
  commentCount = 0,
  children
}) => {
  return (
    <Container className={className}>
      <ChildrenContainer>
        {children}
      </ChildrenContainer>
      <InfoContainer>
        <Uploader>
          <img src={avatar} alt="uploader avatar" />
          <span>{name}</span>
        </Uploader>
        <Counts>
          <Count>
            <CountIcon code="liulan" />
            <span>{viewCount}</span>
          </Count>
          {/*<Count>*/}
          {/*  <CountIcon code="zan_dianji" />*/}
          {/*  <span>{likeCount}</span>*/}
          {/*</Count>*/}
          {/*<Count>*/}
          {/*  <CountIcon code="liuyan" />*/}
          {/*  <span>{commentCount}</span>*/}
          {/*</Count>*/}
        </Counts>
      </InfoContainer>
    </Container>
  )
}
